import React, { useState } from 'react';
import EyeOpenIcon from './EyeOpenIcon';
import EyeClosedIcon from './EyeClosedIcon';

interface EyeToggleProps {
  onClick: () => void;
  isVisible: boolean;
  disabled?: boolean;
}

const EyeToggle: React.FC<EyeToggleProps> = ({ onClick, isVisible, disabled }) => {
  return (
    <div className="relative pb-2 pt-2.5 ml-4">
      <div className="group relative">
        <button
          type="button"
          onClick={onClick}
          className={`absolute -right-[0.3rem] top-1/2 translate-y-[-50%] bg-transparent border-none ${
            disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          }`}>
          {!isVisible ? <EyeOpenIcon /> : <EyeClosedIcon />}
        </button>

        <div className="absolute -top-9 left-1/2 -translate-x-[70%] z-10 scale-95 opacity-0 group-hover:opacity-100 group-hover:scale-100 transition-all bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 rounded-lg shadow px-2 py-1">
          {!isVisible ? 'Activated' : 'Deactivated'}
        </div>
      </div>
    </div>
  );
};

export default EyeToggle;
